var exports = {
  "xW": "ProductAnnouncementModalDropdown__input__tu3afT",
  "Mo": "ProductAnnouncementModalDropdown__input-label__UH98PJ",
  "Nu": "ProductAnnouncementModalDropdown__input-content__PBmfoA",
  "UY": "ProductAnnouncementModalDropdown__item-icon__kFFjdd",
};

module.exports = exports;
